import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { calcSizeForDevice } from 'utils/index';

type TitleCardProps = {
  title?: string;
  reference?: string;
};

const TitleCard: React.FC<TitleCardProps> = ({ title = '', reference = '' }) => {
  const isSeeMore = reference === 'Ver Mais';

  return (
    <View
      style={[
        styles.card,
        {
          backgroundColor: isSeeMore ? '#ffffff29' : 'transparent',
        },
      ]}>
      <Text
        style={[
          styles.text,
          {
            fontFamily: isSeeMore ? theme.fonts.inter.bold : theme.fonts.inter.regular,
            fontSize: isSeeMore ? calcSizeForDevice(24) : calcSizeForDevice(18),
          },
        ]}>
        {title || reference}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 10,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: '#ffffff29',
    borderRadius: 3,
  },
  text: {
    color: '#fff',
    textAlign: 'center',
  },
});

export default TitleCard;
